import React from "react";

import SearchImage from "../images/Search.png";
import { isNumber } from "../../../utilities/helpers";

const LoanRequestDetailsCard = ({
  amount,
  installment_amount,
  installment_frequency,
  installment_count,
  loading = false,
  error = false,
  errorMessage = "",
}) => {
  const loanRequestDetails = [
    { label: "Loan Amount", value: isNumber(amount) ? Number(amount) : "N/A" },
    {
      label: "Installment Amount",
      value: isNumber(installment_amount) ? Number(installment_amount) : "N/A",
    },
    {
      label: "Installment Frequency",
      value: installment_frequency || "N/A",
    },
    {
      label: "Installment Count",
      value: isNumber(installment_count) ? Number(installment_count) : "N/A",
    },
  ];

  if (loading) {
    return (
      <div className="card-section">
        <h3 className="card-section__title">Request Details</h3>
        {[...Array(4)].map((_, index) => (
          <div className="detail-item" key={index}>
            <div className="skeleton skeleton-text skeleton-text--small"></div>
            <div className="skeleton skeleton-text skeleton-text--medium"></div>
          </div>
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="card-section">
        <h3 className="card-section__title">Request Details</h3>
        <div className="error-state">
          <img src={SearchImage} alt="Error" className="error-image" />
          <h4 className="error-title">Error Fetching Data</h4>
          <p className="error-message">{errorMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="card-section">
      <h3 className="card-section__title">Request Details</h3>
      {loanRequestDetails.map((item, index) => (
        <div className="detail-item" key={index}>
          <span className="label">{item.label}</span>
          <span className="value text-right-align">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default LoanRequestDetailsCard;
